import PropTypes from 'prop-types';
import { useState } from 'react';
import profile from 'src/store/profile';
import api from 'src/utils/api';
// @mui
import { Stack, TextField, Snackbar, Alert } from '@mui/material';
import { LoadingButton } from '@mui/lab';

// ----------------------------------------------------------------------

AddVideoForm.propTypes = {
  success: PropTypes.func.isRequired,
};

export default function AddVideoForm({ success }) {
  const [title, setTitle] = useState('');
  const [text, setText] = useState('');
  const [url, setUrl] = useState('');
  const [error, setError] = useState('');
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'error' });

  const handleClick = () => {
    if (title !== '' && url !== '')
      api.post('video-api/create', { title, url, text, type: 2, student_id: profile.data.id })
        .then((result) => {
          if (result.id) success();
          else if (result.status === "error") setError(result.message);
        })
        .catch((err) => {
          api.logError('add video failed', err);
          setError('true');
          setSnackbar({ open: true, message: err?.message || 'Помилка при додаванні відео', severity: 'error' });
        });
    else setError('true');
  };

  return (
    <>
      <Stack spacing={3}>
        <TextField name="title" label="Заголовок" value={title} error={Boolean(error)}
          onChange={(event) => {
            setTitle(event.target.value);
          }} />

        <TextField name="text" multiline rows={4} label="Опис (не обов'язково)" value={text} error={Boolean(error)}
          onChange={(event) => {
            setText(event.target.value);
          }} />

        <TextField name="url" label="Youtube id" value={url} error={Boolean(error)}
          onChange={(event) => {
            setUrl(event.target.value);
          }} />

        <LoadingButton fullWidth size="large" type="submit" variant="contained" onClick={handleClick}>
          Додати
        </LoadingButton>
      </Stack>
      <Snackbar open={snackbar.open} autoHideDuration={4000} onClose={() => setSnackbar(s => ({ ...s, open: false }))} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}>
        <Alert onClose={() => setSnackbar(s => ({ ...s, open: false }))} severity={snackbar.severity} sx={{ width: '100%' }}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </>
  );
}
